import React from 'react';
import FormInput from './FormInput';

const EdutechForm = ({ vinculo, setVinculo }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name.startsWith('config.')) {
      const configKey = name.split('.')[1];
      setVinculo(prev => ({
        ...prev,
        config: {
          ...prev.config,
          [configKey]: value
        }
      }));
    } else {
      setVinculo(prev => ({ ...prev, [name]: value }));
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <FormInput
        label="Nome da Organização"
        name="nome_organizacao"
        value={vinculo.nome_organizacao}
        onChange={handleChange}
        required
        placeholder="Ex: Escola ABC"
      />

      <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-2">
        <h4 className="text-base font-semibold text-gray-900 dark:text-white mb-3">
          Dados do usuário principal (Administrador)
        </h4>

        <div className="flex flex-col gap-4">
          <FormInput
            label="Nome"
            name="nome_usuario"
            value={vinculo.nome_usuario}
            onChange={handleChange}
            required
            placeholder="Ex: João da Silva"
          />

          <FormInput
            label="E-mail"
            type="email"
            name="email_cliente"
            value={vinculo.email_cliente}
            onChange={handleChange}
            required
            placeholder="cliente@escola.com"
          />

          <FormInput
            label="Senha"
            type="password"
            name="senha"
            value={vinculo.senha}
            onChange={handleChange}
            required
            placeholder="••••••••"
          />
        </div>
      </div>

      <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-2">
        <h4 className="text-base font-semibold text-gray-900 dark:text-white mb-3">
          Configurações do Edutech
        </h4>
        
        <div className="grid grid-cols-2 gap-3">
          <FormInput
            label="Máx. Alunos"
            type="number"
            name="config.max_alunos"
            value={vinculo.config.max_alunos}
            onChange={handleChange}
            min="1"
          />

          <FormInput
            label="Máx. Professores"
            type="number"
            name="config.max_professores"
            value={vinculo.config.max_professores}
            onChange={handleChange}
            min="1"
          />

          <div className="col-span-2">
            <FormInput
              label="Máx. Turmas"
              type="number"
              name="config.max_turmas"
              value={vinculo.config.max_turmas}
              onChange={handleChange}
              min="1"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EdutechForm;

